<template>
  <div v-if="isNotificationDataPresent" class="notifcationTab">
    <BaseIcon
      name="alertNotificationBanner"
      class="alertIcon"
      width="1.5em"
      height="1.5em"
    />
    <span class="notification-text">
      {{ notificationMessage }}
    </span>
    <div class="right">
      <button class="dialogCloseButton" @click="$emit('closeNotification')">
        <BaseIcon name="closeButton-mini" />
      </button>
    </div>
  </div>
</template>
<script>
import graphQl from '@/services/graphQl';
import { formatDate } from '@/utils/time/formatDate';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      notificationData: [],
      startTimeDate: '',
      endTimeDate: '',
      notificationMessage: '',
    };
  },
  name: 'TopNotification',
  methods: {
    async getNotificationData() {
      try {
        const { data } = await graphQl
          .query('querynotificationtime')
          .params({});
        this.notificationData = data?.data?.response;
        if (this.notificationData.length > 0) {
          this.notificationMessage = this.notificationData[0]?.message;

          this.startTimeDate = formatDate(
            this.notificationData[0]?.startTime,
            this.timezoneoffset,
            'MMM DD, YYYY [at] hh:mm A',
          );

          this.endTimeDate = formatDate(
            this.notificationData[0]?.endTime,
            this.timezoneoffset,
            'MMM DD, YYYY [at] hh:mm A',
          );
        }
      } catch (error) {
        console.log(error);
        this.notificationData = [];
      }
    },
  },
  computed: {
    ...mapState('globalState/settings', ['timezoneoffset']),
    isNotificationDataPresent() {
      return this.notificationData.length > 0;
    },
  },
  watch: {
    timezoneoffset() {
      this.getNotificationData();
    },
  },
  created() {
    this.getNotificationData();
  },
};
</script>
<style lang="scss" scoped>
.notifcationTab {
  @include flex-center-justify(flex-start);
  padding-left: 0.938rem;
}

.right {
  margin-left: auto;
}

.dialogCloseButton {
  background-color: transparent;
  border: transparent;
  color: #f59600;
  padding-top: 0.938rem;
  padding-bottom: 0.938rem;
}

.notification-text {
  padding-top: 0.938rem;
  padding-bottom: 0.938rem;
  color: $bg-dark-black;
  text-align: start;
}

.alertIcon {
  padding-top: 0.938rem;
  padding-bottom: 0.638rem;
  fill: $bg-dark-black;
}
</style>
